/**
 * Agent “Ready to call” badge — must match script/infields validation,
 * not only “agent is linked”.
 */

export function resolveAgentReadyDisplay({
  agentSetupStatus = '',
  generatingPrompt = false,
  scriptValidationOk = false,
} = {}) {
  if (agentSetupStatus === 'setting_up') return 'setting_up'
  if (agentSetupStatus === 'error') return 'error'
  if (agentSetupStatus === 'ready') {
    if (generatingPrompt) return 'setting_up'
    if (!scriptValidationOk) return 'blocked'
    return 'ready'
  }
  return agentSetupStatus || ''
}

export function resolveAgentReadyLabel({
  agentSetupStatus = '',
  generatingPrompt = false,
  scriptValidationOk = false,
  validationError = '',
} = {}) {
  if (agentSetupStatus === 'ready' && generatingPrompt) {
    return 'Updating the script…'
  }
  if (agentSetupStatus === 'ready' && !scriptValidationOk) {
    return validationError || 'Job details are missing — fill them before the test call.'
  }
  return 'Ready to call'
}

export function isAgentReadyToCall(opts = {}) {
  return resolveAgentReadyDisplay(opts) === 'ready'
}
